export default "__VITE_ASSET__skm3Ho11__"